import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Button, useMediaQuery, useTheme } from "@material-ui/core";
import logo from "./logo.png";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Message from "./Message";
import Formservice from "./../service/Formservice";
import Menu from "./Menu";
import { Grid } from "@mui/material";
import Identifiant from "./reusable/Identifiant";
import NB from "./reusable/NB";
import { LoadingButton } from "@mui/lab";

function Fichier() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  // const params = new URLSearchParams(location.search);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const ref = localStorage.getItem("ref");
  const parts = ref.split("_");
  const prefix = parts[0];
  const [valeur, setValeur] = useState({});
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [form, setForm] = useState({
    signature: "",
    photo: "",
    lm: "",
    nif: "",
    stat: "",
    date_nif: "",
    num_nif: "",
    num_stat: "",
  });

  // function onFileChange(event) {
  //     const { name, value } = event.target;
  //     const file = event.target.files[0];
  //     setForm({
  //         ...form,
  //         [name]: file
  //     });
  // }
  function onFileChange(event) {
    const { name, files } = event.target;
    const file = files[0];

    if (!file) {
      return;
    }

    const maxFileSize = 3 * 1024 * 1024;
    if (file.size > maxFileSize) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: `Le fichier ${file.name} est trop volumineux. La taille maximale est de 3 Mo.`,
      });
      event.target.value = "";
      return;
    }

    let allowedTypes = [];
    switch (name) {
      case "lm":
        allowedTypes = ["application/pdf"];
        break;
      case "signature":
      case "photo":
        allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        break;
      case "nif":
      case "stat":
        allowedTypes = [
          "application/pdf",
          "image/jpeg",
          "image/png",
          "image/jpg",
        ];
        break;
      default:
        allowedTypes = [];
    }

    if (!allowedTypes.includes(file.type)) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo: `Le fichier ${file.name} n'est pas autorisé. Types autorisés : ${allowedTypes.join(", ")}.`,
      });
      event.target.value = "";
      return;
    }

    setForm({
      ...form,
      [name]: file,
    });
  }

  function calculateOccurrences(value) {
    if (value) {
      const cin = value.replace(/[^\d]/g, "");
      const number = cin.length;
      if (number < 5) {
        return cin;
      }
      if (number < 7) {
        return `${cin.slice(0, 5)} ${cin.slice(5, 7)}`;
      }
      if (number < 11) {
        return `${cin.slice(0, 5)} ${cin.slice(5, 7)} ${cin.slice(7, 11)}`;
      }
      if (number < 12) {
        return `${cin.slice(0, 5)} ${cin.slice(5, 7)} ${cin.slice(7, 11)} ${cin.slice(11, 12)}`;
      }

      return `${cin.slice(0, 5)} ${cin.slice(5, 7)} ${cin.slice(7, 11)} ${cin.slice(11, 12)} ${cin.slice(12, 17)}`;
    } else {
      return "";
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;

    if (form.num_stat) {
      const newval = calculateOccurrences(value);
      setForm({
        ...form,
        [name]: newval,
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  }

  const handleenvoie = () => {
    //Vérifier si le champ "lm" est vide (uniquement si prefix !== "CI")
    if (prefix !== "CI" && (form.lm === "" || form.lm === null)) {
      setMessage({
        ...message,
        open: true,
        color: "red",
        messageInfo:
          "Veuillez télécharger la lettre de motivation (fichier PDF).",
      });
      return;
    }

    setSubmitting(true);
    // Si tout est valide, enregistrer les fichiers
    Formservice.savefile(form, ref)
      .then((result) => {
        if (result.status) {
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: "Succès",
          });
          navigate("/resume");
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: "Erreur lors de l'enregistrement des fichiers.",
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "Erreur lors de l'enregistrement des fichiers.",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }
  const [identif, setIdentif] = useState({});

  const handleretour = () => {
    if (identif.desc === "Cons_ext") {
      navigate("/pretention_location");
    } else {
      if (["Cons_int"].includes(identif.desc)) {
        navigate("/disponibilite");
      } else {
        navigate("/autrecompetence");
      }
    }
  };

  useEffect(() => {
    Formservice.identifiant(ref).then((result) => {
      if (result && result.data) {
        setIdentif(result.data);
        setForm({
          signature: "",
          photo: result.data.photo,
          lm: result.data.lm,
          nif: "",
          stat: "",
          date_nif: result.data.date_nif,
          num_nif: result.data.num_carte_fiscal,
          num_stat: result.data.numero_carte_stat,
        });
      } else {
      }
    });
    Formservice.details(ref).then((result) => {
      if (result && result.data) {
        //  setIdentif(result.data);
        setValeur(result.data);
      } else {
      }
    });
  }, []);

  return (
    <Grid container style={{ display: "flex", justifyContent: "center" }}>
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
      <Menu />
      <header
        style={{
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      ></header>
      <Grid
        item
        xs={12}
        md={10}
        lg={7}
        minHeight={"90vh"}
        borderRadius={"20px"}
        border={"2px rgba(11, 93, 208,0.5) solid "}
        boxShadow="0px 4px 10px rgba(7,71,161,0.4)"
        display={"flex"}
        flexDirection={"column"}
        p={2.5}
      >
        <main>
          <Grid container item xs={12} justifyContent={"center"}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{
                maxWidth: "75px",
                maxHeight: "75px",
                // marginLeft: "40%",
                // display: window.innerWidth <= 600 ? "block" : "none",
              }}
            />
          </Grid>
          <Grid container justifyContent="center">
            <Grid container item xs={12} justifyContent="center">
              <h1 style={{ marginBottom: "10px", textAlign: "center" }}>
                Fichiers
              </h1>
            </Grid>
            <Grid container>
              <Grid item xs={12} md={6}>
                {/* <fieldset>
                  <legend>Identifiant</legend>

                  <label style={{ textAlign: "center" }}>
                    Référence du Dossier :{ref}
                  </label>
                  <br />
                  <label>Nom : {identif.nom}</label>
                  <br />
                  {prefix !== "CI" && <label>Poste : {identif.poste}</label>}
                  <br />
                </fieldset> */}
                <Identifiant identif={identif} prefix={prefix} refer={ref} />
              </Grid>
              <Grid item xs={12} md={6} style={{ color: "red" }}>
                {/* <fieldset>
                  <legend>NB</legend>
                  <label>- Tous les champs avec * sont obligatoires.</label>
                  <br />
                  <label>
                    - Le bouton Ajouter permet d'enregistrer les experience.
                  </label>
                  <br />
                  <label>
                    - Veuillez cliquer sur suivant pour passer au suivant.
                  </label>
                </fieldset> */}
                <NB
                  texts={[
                    "Tous les champs avec * sont obligatoires",
                    "Veuillez cliquer sur suivant pour passer au suivant.",
                  ]}
                />
              </Grid>
            </Grid>

            {/* Section Fichiers */}
            <fieldset
              style={{ width: isMobile ? "90vw" : "55vw", margin: "auto" }}
            >
              <legend>Fichiers</legend>
              <Grid container spacing={3}>
                {prefix !== "CI" && (
                  <>
                    <Grid item xs={12} md={3}>
                      <label>Lettre de motivation *:</label>
                    </Grid>
                    <Grid item xs={12} md={9}>
                      <input
                        type="file"
                        name="lm"
                        onChange={onFileChange}
                        accept=".pdf"
                        style={{ width: "100%" }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} md={3}>
                  <label>Scan signature sous forme image :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <input
                    type="file"
                    name="signature"
                    onChange={onFileChange}
                    accept="image/*"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Photo d'identité :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <input
                    type="file"
                    name="photo"
                    onChange={onFileChange}
                    accept="image/*"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Date mise à jour NIF valable jusqu'au :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    name="date_nif"
                    size="small"
                    variant="outlined"
                    style={{ width: "100%" }}
                    type="date"
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Numéro NIF :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    name="num_nif"
                    size="small"
                    value={form.num_nif}
                    variant="outlined"
                    style={{ width: "100%" }}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Carte NIF :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <input
                    type="file"
                    name="nif"
                    onChange={onFileChange}
                    accept=".pdf, .jpg, .png"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Numéro STAT :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <TextField
                    name="num_stat"
                    size="small"
                    value={form.num_stat}
                    inputProps={{ maxLength: 21 }}
                    variant="outlined"
                    style={{ width: "100%" }}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <label>Carte STAT :</label>
                </Grid>
                <Grid item xs={12} md={9}>
                  <input
                    type="file"
                    name="stat"
                    onChange={onFileChange}
                    accept=".pdf, .jpg, .png"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} md={12}></Grid>
              </Grid>
            </fieldset>
          </Grid>

          {/* Boutons Retour et Suivant */}
          <Grid
            item
            xs={12}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            mt={4}
          >
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                style={{
                  fontWeight: 600,
                  width: isMobile ? "100%" : "auto",
                  marginBottom: "20px",
                }}
                onClick={handleretour}
              >
                Retour
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                loading={submitting}
                variant="outlined"
                color="primary"
                style={{
                  fontWeight: 600,
                  width: isMobile ? "100%" : "auto",
                  marginBottom: "20px",
                }}
                onClick={handleenvoie}
              >
                Suivant
              </LoadingButton>
            </Grid>
          </Grid>
        </main>
        <footer
          style={{
            color: "#0747a1",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          &copy; {new Date().getFullYear()} FID - FONDS D'INTERVENTION POUR LE DEVELOPPEMENT
        </footer>
      </Grid>
    </Grid>
  );
}

export default Fichier;
